/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSubmissionsSummarySecretariat } from '../../models/page-submissions-summary-secretariat';
import { SubmissionsStatusFilterEnum } from '../../models/submissions-status-filter-enum';

export interface GetSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params {
  id: string;
  org: string;

/**
 * Submission status filter
 */
  status?: (Array<SubmissionsStatusFilterEnum> | null);
  companyName?: (string | null);
  sortStatus?: ('asc' | 'desc' | null);
  sortModifiedOn?: ('asc' | 'desc' | null);

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet(http: HttpClient, rootUrl: string, params: GetSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSubmissionsSummarySecretariat>> {
  const rb = new RequestBuilder(rootUrl, getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.query('status', params.status, {});
    rb.query('companyName', params.companyName, {});
    rb.query('sortStatus', params.sortStatus, {});
    rb.query('sortModifiedOn', params.sortModifiedOn, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSubmissionsSummarySecretariat>;
    })
  );
}

getSubmissionsSummaryBySubmissionsCycleApiV2SecretariatSubmissionsOrgSubmissionsCycleIdSubmissionsSummaryGet.PATH = '/api/v2/secretariat/submissions/{org}/submissions-cycle/{id}/submissions/summary';
